import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal fade show d-block brand-modal",
  tabindex: "-1",
  "aria-modal": "true",
  role: "dialog"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_3 = { class: "modal-content border-0 shadow-lg rounded-4" }
const _hoisted_4 = { class: "modal-header border-bottom-dashed" }
const _hoisted_5 = { class: "modal-chip" }
const _hoisted_6 = { class: "modal-title fw-bold mt-3 mb-1" }
const _hoisted_7 = { class: "text-muted mb-0" }
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = { class: "modal-body p-4 p-xl-40" }
const _hoisted_10 = { class: "row g-3" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "field-header" }
const _hoisted_13 = { class: "form-label fw-semibold text-title mb-0" }
const _hoisted_14 = { class: "field-caption" }
const _hoisted_15 = { class: "reference-input-wrap" }
const _hoisted_16 = ["value", "placeholder"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = { class: "field-header" }
const _hoisted_21 = { class: "form-label fw-semibold text-title mb-0" }
const _hoisted_22 = { class: "field-caption" }
const _hoisted_23 = ["value", "placeholder"]
const _hoisted_24 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_25 = { class: "col-md-7" }
const _hoisted_26 = { class: "field-header" }
const _hoisted_27 = { class: "form-label fw-semibold text-title mb-0" }
const _hoisted_28 = { class: "field-caption" }
const _hoisted_29 = ["value", "placeholder"]
const _hoisted_30 = { class: "col-md-5" }
const _hoisted_31 = { class: "field-header" }
const _hoisted_32 = { class: "form-label fw-semibold text-title mb-0" }
const _hoisted_33 = { class: "field-caption" }
const _hoisted_34 = { class: "upload-shell" }
const _hoisted_35 = ["src", "alt"]
const _hoisted_36 = {
  key: 1,
  class: "upload-placeholder"
}
const _hoisted_37 = ["src", "alt"]
const _hoisted_38 = { class: "mb-1 fw-semibold text-title" }
const _hoisted_39 = { class: "small text-muted" }
const _hoisted_40 = { class: "col-md-6" }
const _hoisted_41 = { class: "field-header" }
const _hoisted_42 = { class: "form-label fw-semibold text-title mb-0" }
const _hoisted_43 = { class: "field-caption" }
const _hoisted_44 = ["value"]
const _hoisted_45 = { value: "1" }
const _hoisted_46 = { value: "0" }
const _hoisted_47 = { class: "d-flex justify-content-between align-items-center mt-4 pt-2" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.open)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.isEdit ? _ctx.$t("brand_page.edit_chip") : _ctx.$t("brand_page.new_chip")), 1),
                _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.isEdit ? _ctx.$t("brand_page.update_title") : _ctx.$t("brand_page.create_title")), 1),
                _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("brand_page.modal_description")), 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "btn-close shadow-none",
                "aria-label": _ctx.$t('common.close'),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
              }, null, 8, _hoisted_8)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("brand_page.code")), 1),
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("brand_page.code_caption")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("input", {
                      value: _ctx.form.code,
                      type: "text",
                      class: _normalizeClass(["form-control modal-input", { 'is-invalid': _ctx.errors.code }]),
                      placeholder: _ctx.$t('brand_page.code_placeholder'),
                      onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update-field', 'code', ($event.target as HTMLInputElement).value)))
                    }, null, 42, _hoisted_16),
                    (!_ctx.isEdit)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "btn btn-light generate-code-btn",
                          disabled: _ctx.loading,
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('generate-code')))
                        }, [
                          _cache[10] || (_cache[10] = _createElementVNode("i", { class: "ri-refresh-line me-1" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("brand_page.generate")), 1)
                        ], 8, _hoisted_17))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.errors.code)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.errors.code[0]), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t("brand_page.name")), 1),
                    _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("brand_page.name_caption")), 1)
                  ]),
                  _createElementVNode("input", {
                    value: _ctx.form.name,
                    type: "text",
                    class: _normalizeClass(["form-control modal-input", { 'is-invalid': _ctx.errors.name }]),
                    placeholder: _ctx.$t('brand_page.name_placeholder'),
                    onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update-field', 'name', ($event.target as HTMLInputElement).value)))
                  }, null, 42, _hoisted_23),
                  (_ctx.errors.name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.errors.name[0]), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t("brand_page.description")), 1),
                    _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t("brand_page.description_caption")), 1)
                  ]),
                  _createElementVNode("textarea", {
                    value: _ctx.form.description,
                    rows: "5",
                    class: "form-control modal-input modal-textarea",
                    placeholder: _ctx.$t('brand_page.description_placeholder'),
                    onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update-field', 'description', ($event.target as HTMLTextAreaElement).value)))
                  }, null, 40, _hoisted_29)
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t("brand_page.image")), 1),
                    _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t("brand_page.image_caption")), 1)
                  ]),
                  _createElementVNode("label", _hoisted_34, [
                    _createElementVNode("input", {
                      type: "file",
                      class: "upload-input",
                      accept: "image/*",
                      onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('file-change', $event)))
                    }, null, 32),
                    (_ctx.previewUrl)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.previewUrl,
                          class: "upload-preview",
                          alt: _ctx.$t('brand_page.image_preview_alt')
                        }, null, 8, _hoisted_35))
                      : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _createElementVNode("img", {
                            src: _ctx.fallbackImage,
                            alt: _ctx.$t('brand_page.image_placeholder_alt'),
                            width: "36",
                            class: "mb-2 opacity-50"
                          }, null, 8, _hoisted_37),
                          _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.$t("brand_page.upload_image")), 1),
                          _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t("brand_page.image_hint")), 1)
                        ]))
                  ]),
                  (_ctx.previewUrl && !_ctx.isEdit)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-light btn-sm mt-2",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('remove-image')))
                      }, _toDisplayString(_ctx.$t("brand_page.remove_image")), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.$t("brand_page.status")), 1),
                    _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t("brand_page.status_caption")), 1)
                  ]),
                  _createElementVNode("select", {
                    value: String(_ctx.form.status ?? '1'),
                    class: "form-select modal-input",
                    onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('update-field', 'status', ($event.target as HTMLSelectElement).value)))
                  }, [
                    _createElementVNode("option", _hoisted_45, _toDisplayString(_ctx.$t("brand_page.status_active")), 1),
                    _createElementVNode("option", _hoisted_46, _toDisplayString(_ctx.$t("brand_page.status_inactive")), 1)
                  ], 40, _hoisted_44)
                ])
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light px-4",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('close')))
                }, _toDisplayString(_ctx.$t("common.cancel")), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn style-one px-4 h-55",
                  disabled: _ctx.loading,
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('save')))
                }, [
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_49))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.loading ? _ctx.$t("brand_page.saving") : _ctx.isEdit ? _ctx.$t("brand_page.update_action") : _ctx.$t("brand_page.create_action")), 1)
                ], 8, _hoisted_48)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}